export default [
  {
    "id": "mat-enem-1030",
    "numero": 2530,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Em um jogo de tabuleiro, a pontuação é marca-\nda com fichas coloridas. Cada ficha vermelha \nvale um ponto. Três fichas vermelhas podem \nser trocadas por uma azul, três fichas azuis \npodem ser trocadas por uma branca, e três fi-\nchas brancas podem ser trocadas por uma ver-\nde. Ao final do jogo, os jogadores A, B e C ter-\nminaram, cada um, com as quantidades de fi-\nchas, conforme a tabela seguinte: \n \n \nDe acordo com essa tabela, as classificações \nem primeiro, segundo e terceiro lugares ficaram, \nrespectivamente, para os jogadores: \n \nA) A, B e C. \nB) B, A e C. \nC) C, B e A. \nD) B, C e A. \nE) C, A e B.",
    "alternativas": {
      "E": "C, A e B.",
      "B": "B, A e C.",
      "C": "C, B e A.",
      "D": "B, C e A."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1030,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1031",
    "numero": 2531,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "O gerente de uma empresa sabe que 70% de \nseus funcionários são do sexo masculino e foi \ninformado de que a porcentagem de emprega-\ndos fumantes nessa empresa é de 5% dos ho-\nmens e de 5% das mulheres. Selecionando, ao \nacaso, a ficha de cadastro de um dos funcioná-\nrios, verificou tratar-se de um fumante. \n \nQual a probabilidade de esse funcionário ser do \nsexo feminino? \n \nA) 50,0% \nB) 30,0% \nC) 16,7% \nD) 5,0% \nE) 1,5%",
    "alternativas": {
      "B": "30,0%",
      "D": "5,0%",
      "E": "1,5%",
      "A": "50,0%"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1031,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-1032",
    "numero": 2532,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Em março de 2011, um terremoto de 9,0 graus \nde magnitude na escala Richter atingiu o Japão \nmatando milhares de pessoas e causando \ngrande destruição. Em janeiro daquele ano, um \nterremoto de 7,0 graus na escala Richter atingiu \na cidade de Santiago Del Estero, na Argentina. \nA magnitude de um terremoto, medida pela \nescala Richter, é R = log(\n𝐴\n𝐴0\n), em que A é a am-\nplitude do movimento vertical do solo, informado \nem um sismógrafo, A0 é uma amplitude de refe-\nrência e log representa o logaritmo na base 10. \n \n(Disponível em: http://earthquake.usgs.gov) \n \nA razão entre as amplitudes dos movimentos \nverticais dos terremotos do Japão e da Argenti-\nna é: \n \nA) 1,28 \n \nB) 2,0 \n \nC) 10\n9\n7 \n \nD) 100 \n \nE) 109−107",
    "alternativas": {
      "B": "2,0",
      "D": "100",
      "E": "109−107",
      "A": "1,28"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.2",
    "numeroOriginal": 1032,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];